"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldRenderer = exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _fieldMapperFactory = require("./Helpers/fieldMapperFactory");

var _styles2 = require("./styles");

var _useDebounce = require("use-debounce");

var _FieldWrapper = _interopRequireDefault(require("./FieldWrapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * TODO: Make it so CustomFields that need validation can easily be implemented.
 *
 * Currently seems a bit painful based on what the example in the README.md shows.
 */
var FieldRenderer = function FieldRenderer(props) {
  var toValidate = (0, _react.useRef)({});

  var _useDebouncedCallback = (0, _useDebounce.useDebouncedCallback)(function () {
    var _loop = function _loop() {
      var field = _Object$values[_i];
      props.validate(field).then(function (result) {
        return props.onValidation(field, result);
      }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      });
      delete toValidate.current[field.name];
    };

    for (var _i = 0, _Object$values = Object.values(toValidate.current); _i < _Object$values.length; _i++) {
      _loop();
    }
  }, 600),
      _useDebouncedCallback2 = (0, _slicedToArray2.default)(_useDebouncedCallback, 1),
      debouncedValidation = _useDebouncedCallback2[0];
  /**
   * Handles generating props and rendering a field based based on a model.
   *
   * @param field The field to render
   */


  var renderField = function renderField(field) {
    var _props$fieldMapper, _props$fieldMapper2;

    var fieldConfiguration = props.fieldConfiguration,
        classes = props.classes,
        id = props.id,
        onModelMappingCompleted = props.onModelMappingCompleted,
        variant = props.variant,
        customValidations = props.customValidations,
        customToolbarButtons = props.customToolbarButtons;
    var htmlId = "".concat(id, "-").concat(field.name);
    var mapper = (_props$fieldMapper = (_props$fieldMapper2 = props.fieldMapper) === null || _props$fieldMapper2 === void 0 ? void 0 : _props$fieldMapper2.call(props, field)) !== null && _props$fieldMapper !== void 0 ? _props$fieldMapper : (0, _fieldMapperFactory.defaultFieldMapperFactory)(field);
    var generated = mapper(_objectSpread(_objectSpread({
      display: field.properties.label || field.label || field.name,
      field: field,
      htmlId: htmlId,
      customValidations: customValidations,
      customToolbarButtons: customToolbarButtons
    }, fieldConfiguration), {}, {
      value: field.value
    })) || null;

    if (!generated) {
      return notSupported(field);
    }

    generated.validations = customValidations && (generated.validations || []).concat(customValidations[field.name] || []);
    var model = (onModelMappingCompleted === null || onModelMappingCompleted === void 0 ? void 0 : onModelMappingCompleted(field, generated)) || generated;
    fieldConfiguration && Object.keys(fieldConfiguration).forEach(function (key) {
      model[key] = fieldConfiguration[key];
    });
    var Component = model.component,
        onChange = model.onChange,
        disabled = model.disabled,
        other = (0, _objectWithoutProperties2.default)(model, ["component", "onChange", "disabled"]);

    if (!Component) {
      return notSupported(field, model);
    }

    var disableForm = disabled || (variant === null || variant === void 0 ? void 0 : variant.toLowerCase()) === "readonly"; // Force validations to be disabled so the form itself can control each inputs validation.

    other.doNotValidate = true;

    if (Component) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(htmlId, "-fieldWrapper"),
        className: (0, _classnames.default)("prmbl-formBuilder-fieldWrapper", classes.fieldWrapper)
      }, /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, {
        id: htmlId,
        field: field,
        model: model,
        disabled: disableForm,
        onAttach: function onAttach(component) {
          props.onFieldMounted(field, component);
        },
        onBlur: function onBlur() {
          if (model.onlyValidateOnBlur) {
            toValidate.current[field.name] = field;
            debouncedValidation();
          }
        },
        onChange: function onChange(field, data) {
          var _props$onChange;

          (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, field, data, false);

          if (!model.onlyValidateOnBlur) {
            toValidate.current[field.name] = field;
            debouncedValidation();
          }
        }
      }));
    } else {
      return notSupported(field, model);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "prmbl-fieldRenderer"
  }, props && props.fields && props.fields.map(function (field) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: field.name
    }, renderField(field));
  }));
};

exports.FieldRenderer = FieldRenderer;

function notSupported(field, model) {
  var message;

  if (model === null || model === void 0 ? void 0 : model.message) {
    var _model$message;

    message = (_model$message = model === null || model === void 0 ? void 0 : model.message) !== null && _model$message !== void 0 ? _model$message : field.name + " is not supported yet";
  } else if (field.properties.editor) {
    message = "".concat(field.properties.fieldType, " with ").concat(field.properties.editor, " editor is not supported yet");
  } else {
    message = "".concat(field.properties.fieldType, " is not supported yet");
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: "2em",
      marginBottom: "2em"
    }
  }, message);
}

var _default = (0, _styles.withStyles)(_styles2.styles)(FieldRenderer);

exports.default = _default;